import React, { FC } from 'react';
import { Spellcheck } from '@mui/icons-material';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';
import { useGuideCmsContext } from '../../../GuideCmsContext';

/** Opens Oppslag in the dictionary sidebar with the selected text as the search. */
export const LookUpInDictionaryToolbarButton: FC = () => {
  const editor = useRichTextEditorContext();
  const { openDictionarySearch } = useGuideCmsContext();
  if (!editor) return null;

  const handleOnClick = () => {
    const { from, to } = editor.state.selection;
    openDictionarySearch(editor.state.doc.textBetween(from, to, ' ').trim());
  };

  return <MenuButton IconComponent={Spellcheck} tooltipLabel="Slå opp i ordlista" onClick={handleOnClick} />;
};
